module.exports = __webpack_public_path__ + "static/img/niaosu.c6b2f42b.svg";